<template>
  <div class="report" :class="theme">
    <div class="right-top" v-if="theme == 'blue' && showIndex == 0">
      <div class="content" v-if="jsonData.openEng == 1">
        <img @click="toSearch" class="search" src="../assets/image/red/search.png"/>
        <div class="line">|</div>
        <img v-if="language === 'zh'" class="language" src="../assets/image/red/english.png" @click="changeLan('en')"/>
        <img v-else-if="language === 'en'" class="language" src="../assets/image/red/chinese.png"
             @click="changeLan('zh')"/>
      </div>
      <div class="content2" v-else>
        <img @click="toSearch" class="search" src="../assets/image/red/search.png"/>
      </div>
    </div>
    <div class="right-top blue-bg" v-else-if="theme == 'blue' && showIndex == 1">
      <div class="content" v-if="jsonData.openEng == 1">
        <img @click="toSearch" class="search" src="../assets/image/blue/search_lan.png"/>
        <div class="line">|</div>
        <img v-if="language === 'zh'" class="language" src="../assets/image/blue/english_lan.png"
             @click="changeLan('en')"/>
        <img v-else-if="language === 'en'" class="language" src="../assets/image/blue/chinese_lan.png"
             @click="changeLan('zh')"/>
      </div>
      <div class="content2" v-else>
        <img @click="toSearch" class="search" src="../assets/image/blue/search_lan.png"/>
      </div>
    </div>
    <div class="right-top-y yellow-bg" v-else-if="theme == 'yellow'">
      <div class="content-y" v-if="jsonData.openEng == 1">
        <img v-if="language === 'zh'" class="language" src="../assets/image/yellow/english.png"
             @click="changeLan('en')"/>
        <img v-else-if="language === 'en'" class="language" src="../assets/image/yellow/chinese.png"
             @click="changeLan('zh')"/>
        <div class="line">—</div>
        <img @click="toSearch" class="search" src="../assets/image/yellow/search.png"/>
      </div>
      <div class="content2-y" v-else>
        <img @click="toSearch" class="search" src="../assets/image/yellow/search.png"/>
      </div>
    </div>
    <div class="right-top" v-else>
      <div class="content" v-if="jsonData.openEng == 1">
        <img @click="toSearch" class="search" src="../assets/image/red/search.png"/>
        <div class="line">|</div>
        <img v-if="language === 'zh'" class="language" src="../assets/image/red/english.png" @click="changeLan('en')"/>
        <img v-else-if="language === 'en'" class="language" src="../assets/image/red/chinese.png"
             @click="changeLan('zh')"/>
      </div>
      <div class="content2" v-else>
        <img @click="toSearch" class="search" src="../assets/image/red/search.png"/>
      </div>
    </div>
    <swiper v-if="showPage && !isLongChart" ref="mySwiper" :options="swiperOptions" @slideChange="slideChange">
      <swiper-slide>
        <Home></Home>
      </swiper-slide>
      <swiper-slide v-if="this.menuData.length > 0">
        <Pages v-if="showPages" ref="pages" @goToHomeSlide="goToHomeSlide"></Pages>
      </swiper-slide>
    </swiper>
    <div v-show="showIndex == 0" v-if="!isLongChart" class="swiper-button-next swiper-button-next1"
         slot="button-next"></div>
    <SearchDialog :show.sync="showSearch" v-if="!isLongChart"></SearchDialog>

    <div v-if="isLongChart" style="display: flex;">
      <Home id="page"></Home>
      <div style="display: flex;">
        <div v-for="(item, index) in menuData" :key="item.key" style="flex: 0 0 auto;" :id="'page'+index" class="pages"
             :class="[theme != 'blue' && theme != 'yellow' ? 'pt' : '']">
          <Header></Header>
          <component :is="item.key" :index="index"></component>
          <Footer></Footer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'; // 导入 CryptoJS 加密库
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'; // 导入 Swiper 组件
import {getToken} from '@/utils/jsencrypt'; // 导入获取 token 的工具函数
import 'swiper/css/swiper.min.css'; // 导入 Swiper 的 CSS 样式
import axios from 'axios'; // 导入 axios 库
import html2canvas from 'html2canvas'; // 导入 html2canvas 库
import {saveAs} from 'file-saver'; // 导入 file-saver 库

import Header from '@/components/header.vue'; // 导入头部组件
import Menu from '@/components/menu.vue'; // 导入菜单组件
import Footer from '@/components/footer.vue'; // 导入底部组件
import Grow from '@/views/grow.vue'; // 导入 "增长" 页面组件
import Operating from '@/views/operating.vue'; // 导入 "运营" 页面组件
import Performance from '@/views/performance.vue'; // 导入 "绩效" 页面组件
import Custom1 from '@/views/custom1.vue'; // 导入 "自定义1" 页面组件
import Custom2 from '@/views/custom2.vue'; // 导入 "自定义2" 页面组件
import cStyle1 from '@/views/cStyle1.vue'; // 导入 "样式1" 页面组件
import cStyle2 from '@/views/cStyle2.vue'; // 导入 "样式2" 页面组件
import Profitability1 from '@/views/profitability1.vue'; // 导入 "盈利能力1" 页面组件
import Profitability2 from '@/views/profitability2.vue'; // 导入 "盈利能力2" 页面组件
import Regulatory from '@/views/capital.vue'; // 导入 "资本充足" 页面组件
import Solvency from '@/views/solvency.vue'; // 导入 "偿债能力" 页面组件
import Cash from '@/views/cash'; // 导入 "现金流" 页面组件
import Shareholders from '@/views/shareholders'; // 导入 "股东" 页面组件
import Profile from '@/views/profile'; // 导入 "概览" 页面组件
import Chairman from '@/views/chairman'; // 导入 "董事长" 页面组件
import Announcement from '@/views/announcement'; // 导入 "公告" 页面组件
import Home from '@/views/home.vue'; // 导入首页组件
import Dialog from '@/components/Dialog.vue'; // 导入对话框组件
import SearchDialog from '@/components/SearchDialog'; // 导入搜索对话框组件
import Pages from '@/views/pages.vue'; // 导入页面组件
import {mapState} from 'vuex'; // 导入 Vuex 的 mapState 辅助函数
import JSZip from 'jszip'; // 导入 JSZip 库
import jsonp from 'jsonp'; // 导入 jsonp 库

// 监听 window 的 message 事件，用于接收 UI 项目传递的数据
window.addEventListener('message', (event) => {
  if (event.data === 'callSomeMethodPc') {
    indexInstance.generateLongImage(); // 调用生成长图的方法
  }
});

export default {
  name: 'index', // 定义组件名称
  components: {
    // 注册所有导入的组件
    Swiper,
    SwiperSlide,
    Home,
    Pages,
    Dialog,
    SearchDialog,
    Header,
    Menu,
    Footer,
    Grow,
    Operating,
    Performance,
    cStyle1,
    cStyle2,
    Profitability1,
    Profitability2,
    Regulatory,
    Solvency,
    Cash,
    Shareholders,
    Profile,
    Chairman,
    Announcement,
    Custom1,
    Custom2,
  },
  data() {
    return {
      isTouchCapable: false, // 设备是否支持触摸
      showSearch: false, // 是否显示搜索弹窗
      showPage: false, // 是否显示页面内容
      showPages: true, // 是否显示页面
      swiperOptions: {
        // Swiper 配置
        keyboard: true, // 启用键盘控制
        grabCursor: true, // 鼠标悬停时显示抓手光标
        setWrapperSize: true, // 设置 wrapper 的尺寸
        roundLengths: true, // 将 slide 的宽高取整
        navigation: {
          nextEl: '.swiper-button-next1', // 下一页按钮
        },
      },
      showIndex: 0, // 当前显示的索引
      jsonData: {}, // JSON 数据
      menuData: [], // 菜单数据
      isPreview: false, // 是否为预览模式
      isLongChart: false, // 是否为导出长图模式
      imgBase64List: [], // 图片 Base64 列表
    };
  },
  watch: {
    // 监听搜索弹窗的显示状态
    showSearch(newVal, oldVal) {
      if (!newVal) {
        document.title = this.jsonData.name; // 恢复页面标题
      }
    },
    // 监听语言变化
    language(newData, oldData) {
      if (newData == 'zh') {
        this.menuData = JSON.parse(this.jsonData.moduleData); // 加载中文菜单数据
      } else {
        this.menuData = JSON.parse(this.jsonData.moduleDataEng); // 加载英文菜单数据
      }
    },
  },
  async mounted() {
    // 绑定 window.indexInstance 为当前 Vue 实例
    window.indexInstance = this;
    await this.fetchJsonData(); // 获取 JSON 数据
    if (!this.isLongChart) {
      if (this.showPage) {
        this.$refs.mySwiper.$swiper; // 初始化 Swiper
        this.touchCapable(); // 检测设备是否支持触摸
      }
    }
  },
  computed: {
    // 将 Vuex 的 state 映射到计算属性中
    ...mapState(['theme', 'language', 'envConfig']),
  },
  methods: {
    // 根据浏览器参数获取 JSON 数据
    async fetchJsonData() {
      const that = this;
      let url = window.location.href; // 获取当前页面 URL
      console.log('url = ' + url);
      if (url.indexOf('?') === -1 || !url.split('?')[1]) {
        this.openAlert(); // 如果 URL 中没有参数，弹出提示
        return;
      }
      let key = url.substring(url.indexOf('?') + 1); // 获取 URL 参数
      if (!key) {
        this.openAlert();
        that.showPage = false;
        return;
      }
      if (url.indexOf("=#") !== -1) { // 解决微信转发的问题
        url = url.replace("=#", "#");
      }
      if (key.endsWith('.img')) { // 如果是导出长图
        key = key.substring(0, key.length - 4);
        that.$store.commit('setIsLongChart', true);
        this.isLongChart = true;
      }
      if (key.length === 36 || key.length === 45 || url.endsWith(".json")) {
        // 如果是直接访问 JSON 文件
        let folder = '';
        if (key.indexOf('#') !== -1) {
          let params = key.split("#");
          key = params[0];
          folder = this.insertCharAt(this.insertCharAt(params[1], 4, "/"), 7, "/") + "/";
        }
        let url = this.envConfig.staticUrl + `/datav3/` + folder + key.substring(0, key.length - 4);
        console.log('req = ' + url);
        await axios.get(url).then(response => {
          that.showPage = true;
          that.jsonData = response.data;
          this.processResponseData(that);
        }).catch(error => {
          console.error('Error fetching JSON data:', error);
          this.openAlert();
          that.showPage = false;
        });
      } else {
        // 从服务器获取数据
        let url = this.envConfig.serverUrl + '/open/api/cacheReportData/' + key;
        console.log('api = ' + url);
        await jsonp(url, null, (err, data) => {
          if (err) {
            console.error('请求失败', err);
            that.showPage = false;
            that.openAlert();
            return;
          }
          console.log(data);
          if (data != null && data != "") {
            that.showPage = true;
            that.isPreview = true;
            that.jsonData = data;
            this.processResponseData(that);
            return;
          }
          that.showPage = false;
          that.openAlert();
        });
      }
    },
    // 解密数据
    decrypt(data) {
      const key = CryptoJS.enc.Utf8.parse('abcdefghijklmnop'); // 16 位密钥
      const decrypted = CryptoJS.AES.decrypt(data, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    },
    // 在字符串中插入字符
    insertCharAt(str, index, char) {
      return str.slice(0, index) + char + str.slice(index);
    },
    // 处理响应数据
    processResponseData(that) {
      if (that.jsonData.defaultChn == 1 || (that.jsonData.defaultChn == 0 && that.jsonData.openEng == 0)) { // 不优先展示中文 & 不展示英文 == 展示中文
        this.$store.commit('setLanguage', 'zh');
      } else {
        this.$store.commit('setLanguage', 'en');
      }
      if (that.language == 'zh') {
        document.title = that.jsonData.name;
        this.menuData = JSON.parse(that.jsonData.moduleData);
      } else {
        document.title = that.jsonData.nameEng;
        this.menuData = JSON.parse(that.jsonData.moduleDataEng);
      }
      // that.jsonData.style = 1;
      // 存入 Vuex
      that.$store.commit('setJsonData', that.jsonData);
      if (that.jsonData.style == 1) {
        this.$store.commit('setTheme', 'red');
        window.document.documentElement.setAttribute('theme', 'red');
      } else if (that.jsonData.style == 2) {
        this.$store.commit('setTheme', 'purple');
        window.document.documentElement.setAttribute('theme', 'purple');
      } else if (that.jsonData.style == 3) {
        this.$store.commit('setTheme', 'blue');
        window.document.documentElement.setAttribute('theme', 'blue');
      } else if (that.jsonData.style == 4) {
        this.$store.commit('setTheme', 'yellow');
        window.document.documentElement.setAttribute('theme', 'yellow');
      }

      // 设置财报类型
      if (that.jsonData.period === 'Q1') {
        that.$store.commit('setPeriodName', '一季度');
        that.$store.commit('setPeriodNameEng', 'Q1');
      } else if (that.jsonData.period === 'Q3') {
        that.$store.commit('setPeriodName', '前三季度');
        that.$store.commit('setPeriodNameEng', 'Q1-Q3');
      } else if (that.jsonData.period === 'half') {
        that.$store.commit('setPeriodName', '半年度');
        that.$store.commit('setPeriodNameEng', 'H1');
      } else if (that.jsonData.period === 'year') {
        that.$store.commit('setPeriodName', '年度');
        that.$store.commit('setPeriodNameEng', 'Y');
      }
    },
    // 检测设备是否支持触摸
    touchCapable() {
      this.isTouchCapable = !(
          'ontouchstart' in window ||
          (window.DocumentTouch && document instanceof window.DocumentTouch) ||
          navigator.maxTouchPoints > 0 ||
          window.navigator.msMaxTouchPoints > 0
      );
      this.$refs.mySwiper.$swiper.simulateTouch = this.isTouchCapable;
    },
    // 切换语言
    changeLan(lan) {
      this.$store.commit('setLanguage', lan); // 存入 Vuex
      if (!this.isLongChart) {
        this.$refs.pages.toMenu(-1); // 跳转到菜单
      }
    },
    // Slide 切换时的回调
    slideChange() {
      const realIndex = this.$refs.mySwiper.$swiper.activeIndex; // 获取当前索引
      if (realIndex == 1) {
        this.$refs.mySwiper.$swiper.allowTouchMove = false; // 禁用触摸移动
        this.$refs.mySwiper.$swiper.allowMouseEvents = false; // 禁用鼠标事件
        this.$refs.mySwiper.$swiper.keyboard.disable(); // 禁用键盘控制
        this.showPages = true; // 显示页面
        this.$nextTick(() => {
          this.$refs.pages.goToSlide(realIndex); // 跳转到指定页面
        });
      }
      this.showIndex = realIndex; // 更新当前索引
    },
    // 跳转到下一页
    toNext() {
      this.$refs.mySwiper.$swiper.slideTo(1, 500); // 跳转到第一页
    },
    // 跳转到首页
    goToHomeSlide() {
      this.$refs.mySwiper.$swiper.allowTouchMove = true; // 启用触摸移动
      this.$refs.mySwiper.$swiper.allowMouseEvents = true; // 启用鼠标事件
      this.$refs.mySwiper.$swiper.keyboard.enable(); // 启用键盘控制
      this.$refs.mySwiper.$swiper.update(); // 更新 Swiper
      this.$refs.mySwiper.$swiper.slideTo(0, 500); // 跳转到首页
      this.showPages = false; // 隐藏页面
      this.showIndex = 0; // 更新当前索引
    },
    // 打开提示框
    openAlert() {
      this.$alert('路径或者名称有误，请检查后重新输入', '', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.showSearch = true; // 显示搜索弹窗
            document.title = '聚合搜索'; // 更新页面标题
          }
        },
      });
    },
    // 搜索
    toSearch() {
      if (this.isLongChart || this.isPreview) { // 导出长图或预览时禁用搜索
        return false;
      }
      this.showSearch = true; // 显示搜索弹窗
      document.title = '聚合搜索'; // 更新页面标题
    },
    // 生成长图
    async generateLongImage() {
      const jsonData = this.jsonData;
      this.$store.commit('setJsonData', JSON.parse(JSON.stringify(jsonData).replace(/。《/g, '。《  ').replace(/，《/g, '，《  ').replace(/、《/g, '、《  '))); // 更新 Vuex 数据
      try {
        await this.longImage("page"); // 下载首页
        const imagePromises = this.menuData.map((_, i) => {
          return new Promise((resolve) => {
            this.longImage("page" + i).then(resolve); // 下载每个页面
          });
        });
        await Promise.all(imagePromises); // 等待所有图片下载完成
        this.createZipFile().then((blob) => {
          saveAs(blob, 'image-' + this.language + '-pc.zip'); // 保存为 ZIP 文件
          this.$store.commit('setJsonData', this.jsonData); // 恢复 Vuex 数据
          window.parent.postMessage("callback", "*"); // 发送消息给父页面
          this.imgBase64List.length = 0; // 清空图片列表
        });
      } catch (error) {
        console.error("Error generating long image:", error);
      }
    },
    // 将 HTML 页面转换为图片
    async longImage(id) {
      const node = document.querySelector('#' + id); // 获取页面元素
      await html2canvas(node, {
        scrollY: window.scrollY, // Y 滚动位置
        scrollX: window.scrollX, // X 滚动位置
        x: 2,
        y: 2,
        scale: 2, // 缩放比例
        height: node.scrollHeight - 2, // 页面高度
        width: node.scrollWidth - 2, // 页面宽度
        allowTaint: true, // 允许跨域
        useCORS: true, // 使用 CORS
      }).then((canvas) => {
        const url = canvas.toDataURL('image/png').replace(/^data:image\/png/, ''); // 转换为 Base64
        this.imgBase64List.push({content: url, name: 'image-' + this.language + '-pc'}); // 添加到图片列表
      });
    },
    // 将 Base64 转换为 Blob
    base64ToBlob(base64) {
      const base64WithoutPrefix = base64.split(',')[1]; // 去掉 Base64 前缀
      const binary = atob(base64WithoutPrefix); // 解码为二进制数据
      const array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i)); // 转换为字节数组
      }
      return new Blob([new Uint8Array(array)], {type: 'image/png'}); // 创建 Blob 对象
    },
    // 将 Base64 转换为 Blob（另一种实现方式）
    base64ToBlob1(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {
        type: contentType
      });
    },
    // 创建 ZIP 文件
    async createZipFile() {
      const zip = new JSZip(); // 创建 ZIP 对象
      for (let i = 0; i < this.imgBase64List.length; i++) {
        let ele = this.imgBase64List[i];
        const blob = this.base64ToBlob1(ele.content); // 将 Base64 转换为 Blob
        await zip.folder(ele.name).file((parseInt(i) + 1) + ".png", blob, {binary: true}); // 添加文件到 ZIP
      }
      return zip.generateAsync({type: 'blob'}); // 生成 ZIP 文件
    }
  },
};
</script>
<style scoped>
html,
body {
  overscroll-behavior: none;
}

.report {
  width: 1140px;
  height: 720px;
  position: relative;
}

.right-top {
  position: absolute;
  right: 0;
  top: 0;
  background-image: var(--languageBgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0px 0px 0px 22px;
  padding: 0 10px;
  box-sizing: content-box;
  z-index: 99;
}

.content {
  width: 88px;
  height: 44px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.content2 {
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.line {
  height: 28px;
  font-size: 16px;
  color: #ffffff;
  line-height: 28px;
}

.right-top .search {
  width: 24px;
  height: 24px;
  cursor: pointer; /* 设置光标形状为手型 */
}

.right-top .language {
  width: 24px;
  height: 24px;
  cursor: pointer; /* 设置光标形状为手型 */
}

.swiper-button-next,
.swiper-button-prev {
  color: #dddddd;
}

.blue-bg {
  background-image: url('../assets/image/blue/rectangle_bai.png');
}

.blue-bg .line {
  color: #4782ea;
}

.right-top-y {
  position: absolute;
  right: 0;
  top: 176px;
  background-image: url('../assets/image/yellow/rectangle.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 0px 0px 0px 22px;
  padding: 10px 0;
  box-sizing: content-box;
  z-index: 99;
}

.right-top-y .search {
  width: 24px;
  height: 24px;
  cursor: pointer; /* 设置光标形状为手型 */
}

.right-top-y .language {
  width: 24px;
  height: 24px;
  cursor: pointer; /* 设置光标形状为手型 */
}

.content-y {
  width: 40px;
  height: 118px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content2-y {
  width: 40px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.yellow-bg .line {
  color: #151517;
}

.pages {
  height: 720px;
  position: relative;
  background-image: var(--nyBgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.pt {
  padding: 0 50px;
}

.yellow {

.pages {
  background: #151517;
}

}

.blue {

.pages {
  background: #f4f7fd;
}

}
</style>
